/*eslint-disable */

import accessFeaturesForBlurb from '@/components/public/access-features-of-package-popup';
import axios from 'axios';
import { bus } from '@/main';
import createMeetingInfoPopup from '@/components/private/meeting/create-meeting-info-popup';
import { mapGetters } from 'vuex';
import moment from 'moment';
import removeMeetingPopup from '@/components/private/meeting/meeting-remove-popup';
import root from '@/_helpers/roots';
import thirtyDaysTrail from '@/components/private/thirty-dats-trail-popup';
import toast from '@/services/toast';
import updateMeeting from '@/components/private/meeting/update-meeting-details';

var $ = window.jQuery = require('jquery');
var interval;
let getAllMeetingListURL = root.getAllMeetingListUrl.link;
export default {
  name: 'create-meeting-list',
  components: {
    'edit-meeting' : updateMeeting,
    'create-meeting' : createMeetingInfoPopup,
    'remove-meeting' : removeMeetingPopup,
    'access-feature-of-blurb' : accessFeaturesForBlurb,
    'thirty-days-trail-popup' : thirtyDaysTrail
  },
  props: [],
  data () {
    return {
      createMeetingPopup:false,
      userProfileDetails:null,
      meetingListDetails:null,
      curentDate: new Date(),
      currentUTCDate: '',
      selfUserId:'',
      editMeetingId:'',
      updateMeetingPopup:false,
      countDownMinutes:'',
      countDownSecond:'',
      counterText:'',
      nextPageUrl:'',
      nextSteper:'',
      meetingListResults:[],
      loadmoreData:'',
      userLoading:false,
      removeMeetingPopup:false,
      removeMeetingId:'',
      StaticUUID:'6d5e0cc3-a9d8-4f18-99dc-b5a45d194a52695872',
      staffUserCheck:'',
      domainLocationOrigin:'',
      pro_payment:false,
      auto_payment:false,
      regular_payment:false,
      accessFeaturesOfPackageState:false,
      filterType:'',
      yearState:'',
      monthState:'',
      monthStateVal:'',
      meetingCheckState:'',
      filterEnabledState:false,
      isMobile:false,
      thirtyDaysTrailButton:false,
      thirtyDaysTrailEnded:false,
      thirtyDaysTrailPopupState:false
    }
  },
  computed: {
  ...mapGetters([
    'acUserDetailsStateGetters',
    'getMeetingListGetters'
  ]),
  getUserDetailsInfo(){
    this.userProfileDetails = this.$store.getters.acUserDetailsStateGetters.data;
    return
  },
  getUserDetailsIntialState(){
    if(this.userProfileDetails){
      this.staffUserCheck = this.userProfileDetails.is_staff
      this.pro_payment = this.userProfileDetails.pro_payment
      this.auto_payment = this.userProfileDetails.auto_payment
      this.regular_payment = this.userProfileDetails.regular_payment
    }
  },
  getMeetingList(){
    this.meetingListDetails = this.$store.getters.getMeetingListGetters.data;
    return
  },
  getMeetingIntialState(){
    if(this.meetingListDetails){
      this.nextPageUrl = this.meetingListDetails.next
      this.nextSteper = this.meetingListDetails.next
      this.meetingListResults = [].concat(this.meetingListDetails.results)
    }
  },
  },
  mounted () {
    this.domainLocationOrigin = window.location.origin
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    this.getUserDetailsInfo
    this.getUserDetailsIntialState   
    this.getMeetingList
    this.getMeetingIntialState
    bus.$on('updateMeetingStateBus', (data) => {
      this.updateMeetingPopup = data;
    });
    bus.$on('removeMeetingPopupBus', (data) => {
      this.removeMeetingPopup = data;
    });
    bus.$on('createMeetingPopupBus', (data) => {
      this.createMeetingPopup = data;
      if(!data){
        this.thirtyDaysTrailEnded = false
        this.thirtyDaysTrailButton = false
        this.getThirtyDaysAccessInfoMethod()
      }
    });
    bus.$on('accessFeaturesOfPackageStateBus', (data) => {
      this.accessFeaturesOfPackageState = data;
    });
    bus.$on('thirtyDaysTrailPopupStateBus', (data) => {
      this.thirtyDaysTrailPopupState = data
    })
    this.getThirtyDaysAccessInfoMethod();
  },
  methods: {
    getThirtyDaysAccessInfoMethod(){
      this.$store.dispatch('getThirtyDaysTrailApiUrl').then((res) => {
        if(res.data.data.trial_start_datetime){  
          if(res.data.data.current_datetime > res.data.data.trial_end_datetime){
            this.thirtyDaysTrailEnded = true
            this.thirtyDaysTrailButton = true
          }
        }else{
          this.thirtyDaysTrailButton = true
        }
      })
    },
    meetingCreationForBlurbMethod(){
      this.thirtyDaysTrailPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    onResize() {
      this.isMobile = window.innerWidth < 1023
    },
    clearFiltersMethod(){
      this.filterEnabledState = false
      this.filterType = ''
      this.monthState = ''
      this.monthStateVal = ''
      this.yearState = ''
      this.meetingCheckState = ''
      this.userLoading = true
      this.$store.dispatch('getMeetingAllListFun').then((res) => {
        this.userLoading = false
      }).catch((err) => {
        this.userLoading = false
      })
    },
    filterByKeyMethod(val){
      this.filterEnabledState = true
      this.filterType = val
      this.userLoading = true
      if(this.filterType == 'upcoming'){
        this.meetingCheckState = 'True'
      }else{
        this.meetingCheckState = 'False'
      }
      axios.get(getAllMeetingListURL + '?is_webinar=False' + '&page_size=15' + '&upcoming=' + this.meetingCheckState + '&date_time=' + moment(new Date()).format() + '&year=' + this.yearState + '&month=' + this.monthStateVal).then((response) => {
        this.meetingListDetails = response.data.data
        this.nextPageUrl = this.meetingListDetails.next
        this.nextSteper = this.meetingListDetails.next
        this.meetingListResults = [].concat(this.meetingListDetails.results)
        this.userLoading = false
      })
    },
    filterByYearMethod(val){
      this.filterEnabledState = true
      this.yearState = val
      this.userLoading = true
      axios.get(getAllMeetingListURL + '?is_webinar=False' + '&page_size=15' + '&upcoming=' + this.meetingCheckState + '&year=' + this.yearState + '&month=' + this.monthStateVal).then((response) => {
        this.meetingListDetails = response.data.data
        this.nextPageUrl = this.meetingListDetails.next
        this.nextSteper = this.meetingListDetails.next
        this.meetingListResults = [].concat(this.meetingListDetails.results)
        this.userLoading = false
      })
    },
    filterByMonthMethod(month, val){
      this.filterEnabledState = true
      this.monthState = month
      this.monthStateVal = val
      this.userLoading = true
      this.filterType = ''
      const is_year = this.yearState || moment(new Date()).format('YYYY')
      axios.get(getAllMeetingListURL + '?is_webinar=False' + '&page_size=15' + '&upcoming=' + this.meetingCheckState + '&year=' + is_year + '&month=' + this.monthStateVal).then((response) => {
        this.meetingListDetails = response.data.data
        this.nextPageUrl = this.meetingListDetails.next
        this.nextSteper = this.meetingListDetails.next
        this.meetingListResults = [].concat(this.meetingListDetails.results)
        this.userLoading = false
      })
    },
    userReminderForMeetingMethod(item){
      let payload = {
        id:item.id
      }
      this.$store.dispatch('meetingReminderAction', payload).then((res) => {
        toast.success(res.data.msg);
      })
    },
    accessFeaturesOfPackagemethod(){
      this.accessFeaturesOfPackageState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    urlClipBoardMethod(value) {
      const copyUrl = this.domainLocationOrigin + '/public/meeting/#' + value
      navigator.clipboard.writeText(copyUrl);
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.nextSteper = response.data.data.next
          this.meetingListResults = [].concat(response.data.data.results, this.meetingListResults);
          this.userLoading = false
        });
    },
    updateMeetingMethod(meetingId){
      this.editMeetingId = meetingId
      this.updateMeetingPopup = true
      document.body.classList.add('body_right_scroll_remove')
    },
    startCountdownTimer(joinStartTime,joinEndTime){
      var currentLocalDate = moment().format('MMMM Do YYYY');
      var startDateCheck = moment(joinStartTime).format('MMMM Do YYYY')
      var currentLocalHours = moment().format('HH')
      var currentLocalTime = moment().format('mm:ss')
      var currentLocalSec = moment().format('ss')
      var startTimeHours = moment(joinStartTime).format('HH')
      var startTimeCheck = moment(joinStartTime).format('mm:ss')
      var startTimeSec = moment(joinStartTime).format('mm:ss')
      if(startDateCheck === currentLocalDate){
          var totalMinutesOfStartMeeting  = startTimeHours*parseInt(60) + parseInt(startTimeCheck);
          var totalMinutesOfCurrent  = currentLocalHours*parseInt(60) + parseInt(currentLocalTime);
          if(totalMinutesOfStartMeeting > totalMinutesOfCurrent){
            var validTime = totalMinutesOfStartMeeting - totalMinutesOfCurrent
            // console.log(validTime, "Checking Hours to Mint")
            if(parseInt(11) > validTime){
              this.counterText = validTime + ':' + '00';
              this.countdownTimer()
              return this.counterText;
            }else{
              return false;
            }
          }else{
            return false;
          }
      }else{
        return false;
      }
    },
    countdownTimer() {
      var __self = this
      clearInterval(interval);
      interval = setInterval( function() {
          var timer = $('.js-timeout').html();
          timer = timer.split(':');
          var minutes = timer[0];
          var seconds = timer[1];
          seconds -= 1;
          if (minutes < 0) return;
          else if (seconds < 0 && minutes != 0) {
              minutes -= 1;
              seconds = 59;
          }
          else if (seconds < 10 && length.seconds != 2) seconds = '0' + seconds;
          $('.js-timeout').html(minutes + ':' + seconds);
          if (minutes == 0 && seconds == 0){
            __self.getMeetingListAgain()
            // window.location.reload()
            clearInterval(interval)
          };
      }, 1000);
    },
    enabledJoinBtn(joinStartTime, joinEndTime) {
      var startDateTimeUTC = moment(joinStartTime).local().format();
      var endDateTimeUTC = moment(joinEndTime).local().format();
      var curentDateUTC = moment().local().format();
      if (curentDateUTC > startDateTimeUTC && endDateTimeUTC > curentDateUTC){
        return true;
      }else{   
        return false;
      }
    },
    statusCheckOfMeetingMethod(endTime){
      var startTime2 = moment(endTime).local().format();
      var curentDateUTC = moment().local().format();
      if (startTime2 > curentDateUTC){
        return true;
      }else{   
        return false;
      }
    },
    getMeetingListAgain(){
      this.$store.dispatch('getMeetingAllListFun').then((res)=>{
        this.meetingListDetails = res.data.data
      })
    },
    openCreateMeetingPopup(){
      this.createMeetingPopup = true
      document.body.classList.add('body_right_scroll_remove')
    },
    removeMeetingMethod(removeItemId){
      this.removeMeetingPopup = true
      this.removeMeetingId = removeItemId
      document.body.classList.add('body_right_scroll_remove')
    },
  },
  watch: {
    getUserDetailsInfo(){
      return this.$store.getters.acUserDetailsStateGetters
    },
    getUserDetailsIntialState(){
      if(this.userProfileDetails){
        this.staffUserCheck = this.userProfileDetails.is_staff
        this.pro_payment = this.userProfileDetails.pro_payment
        this.auto_payment = this.userProfileDetails.auto_payment
        this.regular_payment = this.userProfileDetails.regular_payment
      }
    },
    getMeetingList(){
      return this.$store.getters.getMeetingListGetters
    },
    getMeetingIntialState(){
      if(this.meetingListDetails){
        this.nextPageUrl = this.meetingListDetails.next
        this.meetingListResults = [].concat(this.meetingListDetails.results)
      }
    },
    nextSteper(old_val, new_val){
      if(old_val != ''){
        this.nextPageUrl = old_val
        // console.log("New Val:", new_val, "OLD VAL:", old_val )
      }
    },
  },
  beforeRouteLeave: function(to, from, next) {
    document.body.classList.remove('body_right_scroll_remove')
    next();
  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  beforeDestroy() {
    clearInterval(interval);
  },
}